import { useIntl } from "react-intl";

import { CookieAccepted } from "../hook/CookieAccepted";
import TranslatedMessage from "./TranslatedMessage";

const CookieAccept = (props) => {
	const [cookie, setCookie] = CookieAccepted();

	const intl = useIntl();

	let propsMiasto = props.miasto;
	const formattedMessage = "miasta." + propsMiasto + ".cookie";

	return (
		<>
			<section id="pd-cookie-law" className="pd-cookie">
				<div className="pd-cookie__wrapper">
					<h2 className="pd-cookie__title">
						<TranslatedMessage id={formattedMessage + ".title"} />
					</h2>
					<div className="pd-cookie__text">
						<p>
							<TranslatedMessage id={formattedMessage + ".text"} />
						</p>
					</div>
					<div className="pd-cookie__action">
						<a
							href={intl.formatMessage({
								id: formattedMessage + ".action.first.url",
							})}
							className="pd-btn pd-btn--primary-inverse"
							tabIndex={1}
						>
							<TranslatedMessage id={formattedMessage + ".action.first.title"} />
						</a>
						<button onClick={setCookie} className="pd-btn pd-btn--primary" tabIndex={2}>
							<TranslatedMessage id={formattedMessage + ".action.second.title"} />
						</button>
					</div>
				</div>
			</section>
		</>
	);
};

export default CookieAccept;
